export default function SMMHero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/5667d326102a89964cfc4a186f48c236.jpg"
          alt="SMM-стратегия и продвижение в социальных сетях"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0D1B35]/80 via-[#0D1B35]/70 to-[#0D1B35]/80"></div>
      </div>

      <div className="relative z-10 w-full max-w-6xl mx-auto px-4 sm:px-6 py-24 sm:py-28 text-center">
        <div className="inline-flex items-center gap-2 bg-[#C5A880]/40 border border-[#C5A880]/80 text-[#FFE0A8] px-3 sm:px-4 py-2 rounded-full text-xs font-semibold mb-5 font-['Montserrat'] backdrop-blur-sm">
          <i className="ri-instagram-line"></i>
          <span>SMM-стратегия &amp; Продвижение в соцсетях</span>
        </div>

        <h1
          className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-['Playfair_Display'] font-bold text-white mb-5 leading-tight px-1"
          style={{ textShadow: '0 2px 20px rgba(0,0,0,0.9), 0 1px 6px rgba(0,0,0,0.8)' }}
        >
          SMM-стратегия и продвижение:{' '}
          <span className="block mt-1">Соцсети, которые приносят деньги,</span>
          <span className="block mt-1">а не просто лайки</span>
        </h1>

        <p
          className="text-sm sm:text-lg text-white font-semibold mb-8 max-w-4xl mx-auto leading-relaxed font-['Montserrat'] px-1"
          style={{ textShadow: '0 2px 12px rgba(0,0,0,0.85), 0 1px 4px rgba(0,0,0,0.7)' }}
        >
          Получите глубокую Маркетинговую Экспертизу с мощью Искусственного Интеллекта,
          чтобы создать системный канал продаж.
        </p>

        <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center items-center px-4">
          <a
            href="#smm-form"
            className="group w-full sm:w-auto bg-[#C5A880] hover:bg-[#B39770] text-white px-7 py-4 rounded-full text-sm font-semibold transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer font-['Montserrat'] text-center"
          >
            Получить стратегию продвижения
            <i className="ri-arrow-right-line ml-2 group-hover:translate-x-1 transition-transform inline-block"></i>
          </a>
          <a
            href="#smm-difference"
            className="group w-full sm:w-auto bg-white/20 backdrop-blur-md hover:bg-white/30 text-white border-2 border-white/40 px-7 py-4 rounded-full text-sm font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer font-['Montserrat'] text-center"
          >
            Узнать подробнее
          </a>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </section>
  );
}
